module.exports = __webpack_public_path__ + "static/media/revlon0logo.71dd9d15.jpg";